/* eslint-disable import/no-unresolved */
import { Protocals, Promise as _Promise } from 'leancloud-realtime/core';

if (!Protocals) {
  throw new Error('LeanCloud Realtime SDK not installed');
}
export { _Promise };

export { Protocals, EventEmitter } from 'leancloud-realtime/core';
